var map = {
	"./en-us/cms.en-us.yml": 60207,
	"./en-us/forms.en-us.yml": 65420,
	"./en-us/landlord.en-us.yml": 45344,
	"./zh-cn/cms.zh-cn.yml": 70660,
	"./zh-cn/forms.zh-cn.yml": 44980,
	"./zh-cn/landlord.zh-cn.yml": 28813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84905;